export const getCurrentModuleName = () => {
    const path = window.location.pathname;
    const segments = path.split('/').filter(Boolean);

    if (segments.length === 0) return 'Dashboard';

    // taking the first path segment (e.g., "staff", "analytic", "coaching", "report" ...)
    const rawModule = segments[0];

    // Clean up underscores/hyphens
    return rawModule.replace(/[-_]/g, ' ')
};

// ---- Sending the module name on only ONE request as per page visit ----
let prevModuleUrl = null;

export const getModuleOncePerPage = (reqUrl = '') => {
    // Background calls api must not use up the visit
    if (reqUrl.includes('msg_count') || reqUrl.includes('get_key')) return '';

    const module = getCurrentModuleName();
    const pageUrl = window.location.pathname + window.location.search;

    if (!module || pageUrl === prevModuleUrl) return '';

    prevModuleUrl = pageUrl;
    return module;
};

// ---- use this function component when a tab or route changes inside the parent route
// if want to track the child pages if needed ----
export const markNewVisit = () => {
    prevModuleUrl = null;
};